import React from 'react';

const BanerArea = () => {
  return (

    <div className="relative min-h-[60vh] lg:min-h-[50vh]  md:h-96 bg_image_Contact bg-gray-900 overflow-hidden font-inter ">
      {/* Background and overlay */}
      <div className="absolute inset-0 bg-gray-800 opacity-80"></div>

      {/* Blue diagonal gradient overlay */}
      <div className="absolute inset-y-0 right-0 w-3/4 md:w-1/2 lg:w-2/5 bg-gradient-to-br from-transparent to-blue-900 transform -skew-x-12 origin-bottom-right"></div>
      <div className="absolute inset-y-0 right-0 w-3/4 md:w-1/2 lg:w-2/5 bg-gradient-to-br from-transparent to-blue-900 opacity-60 transform -skew-x-12 origin-top-right"></div>

      {/* Main Content */}
      <div className="relative z-10 flex items-center  mt-9 lg:mt-2 md:mt-1  containers h-full px-4 sm:px-12 md:px-20">
        <div className="text-white">

          <h1 className="text-4xl md:text-5xl font-bold">
            Contact
          </h1>
          <p className='lg:w-[50%] md:w-[65%] w-100% lg:mt-4 md:mt-3 mt-2'>
            Let’s build something extraordinary, together. Whether you have a business challenge that needs a technology solution, feedback about our services, or simply want to start a conversation, our team is here to listen and assist
          </p>
        </div>
      </div>
    </div>
  );
};

export default BanerArea;
